module.exports = __webpack_public_path__ + "img/amam_logo.0404e166.png";